import React from "react";

type Props = {
  sidebarOpen?: boolean;
  onToggleSidebar?: () => void;
};

const Topbar: React.FC<Props> = ({ sidebarOpen = true, onToggleSidebar }) => {
  return (
    <header className="admin-topbar d-flex align-items-center px-3 py-2 bg-white border-bottom">
      {/* Only the hamburger menu for mobile – visible only on small screens */}
      <button
        className="btn btn-ghost me-2 d-md-none"
        onClick={onToggleSidebar}
        aria-label="Toggle sidebar"
      >
        <svg width="20" height="25" viewBox="0 0 24 24" fill="none">
          <path
            d="M4 6h16M4 12h16M4 18h16"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {/* No other content – just a clean white bar */}
    </header>
  );
};

export default Topbar;